// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const VulnerableServiceIcon = createSvgIcon(
  <svg width={14} height={15} fill="none" viewBox="0 0 23 24">
    <path
      fill="currentColor"
      d="M15 14.33h2A.67.67 0 0 0 17 13h-2v-1.33h2a.67.67 0 0 0 0-1.34h-2.24a4 4 0 0 0-1.47-1.9L15 6.69a.67.67 0 0 0 0-.94.67.67 0 0 0-.93 0L12 7.76a4 4 0 0 0-1.97.04l-2-2.05a.67.67 0 0 0-1.13.47.7.7 0 0 0 .2.47l1.63 1.66a4 4 0 0 0-1.46 1.9H5a.67.67 0 0 0 0 1.34h2v1.33H5a.67.67 0 0 0 0 1.33h2v1.34H5a.67.67 0 1 0 0 1.33h2.27a4 4 0 0 0 3.06 2.57v-6.85a.67.67 0 0 1 1.34 0v6.9a4 4 0 0 0 3.1-2.54H17a.67.67 0 0 0 0-1.33h-2z"
    />
  </svg>,
  "VulnerableService",
);
export default VulnerableServiceIcon;
